<template>
	<div class="prepare-index i_maxW ">
		<div class="prepare-index-link">
			<router-link to='/prepare'>个人备课</router-link>
			<router-link to='/prepare/collective'>集体备课</router-link>
		</div>
		<div class="prepare-index-cont">
			<router-view />
		</div>
	</div>
</template>

<script type="text/javascript">
	
	export default{
		data(){
			return {
				isActive: false
			}
		},
	}
</script>